import type { NavigateOptions } from 'react-router'
import { useNavigate } from 'react-router'
import { withBase } from 'ufo'
import { useLocation } from 'src/utils/router/route'
import type { EmbeddedRoute } from '../embeddedRoute'

/**
 * Hook to detect if the application is running in embedded mode.
 */
export const useEmbedded = () => {
  const location = useLocation()
  return location.pathname.startsWith('/embedded/')
}

/**
 * A wrapper around `useNavigate` that handles navigation
 *
 * It should only be used in routes that are aware of the platform context
 * and have both normal and embedded versions.
 *
 */
export const useEmbeddedNavigate = () => {
  const isEmbedded = useEmbedded()
  const navigate = useNavigate()

  const navigateTo = (
    to: EmbeddedRoute,
    options?: NavigateOptions & { newPage?: boolean },
  ) => {
    if (isEmbedded) {
      // Prepend '/embedded' to maintain embedded context
      navigate(withBase(to.embedded.toString(), '/embedded'), options)
    } else {
      // Navigate directly in standalone mode

      if (options?.newPage) {
        window.open(to.web.toString(), '_blank')
        return
      }

      navigate(to.web, options)
    }
  }

  return navigateTo
}
